import { render, staticRenderFns } from "./cuHuisartsTemplate.vue?vue&type=template&id=176acb23&scoped=true"
import script from "./cuHuisartsTemplate.vue?vue&type=script&lang=js"
export * from "./cuHuisartsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176acb23",
  null
  
)

export default component.exports